import { render } from "./FormDealer.vue?vue&type=template&id=880bc0ae&ts=true"
import script from "./FormDealer.vue?vue&type=script&lang=ts"
export * from "./FormDealer.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__